import { Link } from "react-router-dom";
import { useRef, useState } from "react";
import { MdOutlineViewAgenda } from "react-icons/md";
import { HiOutlineViewGrid } from "react-icons/hi";
import { FaMapMarkedAlt } from "react-icons/fa";
import { TfiLayoutListThumbAlt } from "react-icons/tfi";

import Container from "../../components/Container";
import SessionsMap from "./SessionsMap";
import SingleSessionCard from "../../components/SingleSession";
import Text from "../../components/Text";
import sessionsList from "./sessionsList.json";
import Pagination from "../../components/Pagination";
import ToggleMapAndCards from "../../components/ToggleMapAndCards";
import ComboBox from "../../components/ComboBox";

const sortOptions = [
  {
    id: 1,
    value: "top-reviews",
    label: "Top reviews",
  },
  {
    id: 2,
    value: "highest-price",
    label: "Highest Price",
  },
  {
    id: 3,
    value: "lowest-price",
    label: "Lowest Price",
  },
  {
    id: 4,
    value: "most-recent",
    label: "Most Recent",
  },
  {
    id: 5,
    value: "option-5",
    label: "Option 5",
  },
  {
    id: 6,
    value: "option-6",
    label: "Option 6",
  },
  {
    id: 7,
    value: "option-7",
    label: "Option 7",
  },
  {
    id: 8,
    value: "option-8",
    label: "Option 8",
  },
  {
    id: 9,
    value: "option-9",
    label: "Option 9",
  },
  {
    id: 10,
    value: "option-10",
    label: "Option 10",
  },
];

const viewsList = [
  {
    id: 1,
    oppositeViewName: "View Map",
    oppositeViewIcon: FaMapMarkedAlt,
    value: "influencers",
  },
  {
    id: 2,
    oppositeViewName: "View Influencers",
    oppositeViewIcon: TfiLayoutListThumbAlt,
    value: "map",
  },
];

const ShortSessions = (props) => {
  const [viewType, setViewType] = useState("list");
  const [currentView, setCurrentView] = useState(viewsList[0]);
  const [map, setMap] = useState(/** @type google.maps.Map */ (null));
  const selectRef = useRef(null);

  const handleViewType = () => {
    setViewType(viewType === "grid" ? "list" : "grid");
  };

  const handleMouseEnter = (location) => {
    map.panTo(location, 10);
  };

  const setSortByType = (event) => {
    const select = selectRef.current;
    const options = select.options;
    for (let i = 0; i < options.length; i++) {
      if (options[i].value === event.target.id) {
        select.selectedIndex = options[i].index;
        return select.options[select.selectedIndex].value;
      }
    }
  };

  return (
    <div className="relative">
      <div className="short-session-wrapper flex bg-white flex-col-reverse">
        {currentView === viewsList[0] && (
          <Container>
            <div className="sessions-list w-full">
              <div className="header flex justify-between xs:items-start md:items-center mb-8 xs:flex-col md:flex-row">
                <div className="headline pr-3 py-4">
                  <Text component={"h2"} classes="text-3xl font-medium">
                    Short Sessions in Istanbul
                  </Text>
                  <Text classes={"text-sm text-[#8b8b8b] font-normal"}>
                    144 Sessions and dietitians found
                  </Text>
                </div>
                <div className="sorting-viewing flex text-[26px]">
                  <button
                    className="grid-view p-1 mr-2 last:mr-0 cursor-pointer"
                    onClick={handleViewType}
                  >
                    {viewType === "grid" ? (
                      <MdOutlineViewAgenda />
                    ) : (
                      <HiOutlineViewGrid />
                    )}
                  </button>
                  <ComboBox
                    selectedClassNames={{ backgroundColor: "bg-secondary-600" }}
                    options={sortOptions}
                  />
                </div>
              </div>
              <div className="sessions-wrapper text-sm text-[#8b8b8b]">
                <ul className="flex flex-wrap justify-between">
                  {sessionsList.map((card, index) => {
                    return (
                      <li
                        className={`single-session py-4 w-full ${
                          viewType === "grid"
                            ? "xs:w-full sm:w-1/2 lg:w-4/12"
                            : null
                        }`}
                        key={index}
                        onMouseEnter={() => {
                          // handeMouseEnter(card.dietitian.location);
                          return;
                        }}
                      >
                        <Link to={"influencer"}>
                          <SingleSessionCard viewType={viewType} />
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="pagination">
                <Pagination />
              </div>
            </div>
          </Container>
        )}

        {currentView === viewsList[1] && (
          <div className="sessions-map w-full h-full -mb-20">
            <SessionsMap setMap={setMap} map={map} />
          </div>
        )}
      </div>
      <div className="sm:inline-block py-4 sticky bottom-0 sm:left-1/2 sm:-translate-x-1/2 z-10">
        <ToggleMapAndCards
          currentView={currentView}
          setCurrentView={setCurrentView}
          viewsList={viewsList}
        />
      </div>
    </div>
  );
};

export default ShortSessions;
